import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "progress-container"
};
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "personalDetails" };
const _hoisted_4 = {
    key: 0,
    class: "well"
};
const _hoisted_5 = { class: "anchor-bottom submitControls" };
import { ref, computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useInsurance } from '@/composables/useInsurance';
import { useContent } from '@/composables/useContent';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import InputSections from './elements/InputSections.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AddInsurancePage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getInsuranceInfo, getInsuranceProviders, getPolicyTypes, getPolicy, addPolicy: apiAddPolicy, updatePolicy } = useInsurance();
        const { getAiopSection } = useContent();
        const inputSections = ref(null);
        const validationText = ref(null);
        const sectionNo = ref(0);
        const currentPageNumber = ref(0);
        const sections = ref([]);
        const policy = ref(null);
        const breadCrumb = ref([]);
        const insuranceHeader = computed(() => {
            if (!sections.value || !sections.value[0] || !sections.value[0].fields || !sections.value[0].fields[0] || !sections.value[0].fields[0].value) {
                return (route.params.id ? 'Edit' : 'Add') + " insurance details";
            }
            return (route.params.id ? 'Edit' : 'Add') + " " + sections.value[0].fields[0].value + " Insurance details";
        });
        const progressValue = computed(() => {
            if (totalPages.value === 0)
                return 0;
            return ((currentPageNumber.value + 1) / totalPages.value) * 100;
        });
        const totalPages = computed(() => {
            const insuranceType = findFieldValue('Policy type');
            return sectionsAvailableCount(insuranceType);
        });
        const isCurrentSectionValid = computed(() => {
            if (!sections.value || !sections.value[sectionNo.value] || !sections.value[sectionNo.value].fields) {
                return false;
            }
            const currentFields = sections.value[sectionNo.value].fields;
            for (const field of currentFields) {
                if (field.required && (!field.value || field.value === "")) {
                    return false;
                }
            }
            return true;
        });
        // --- Helpers (inlined from Helpers mixin) ---
        function stringToDate(dateString) {
            if (!dateString || dateString === 'NaN/NaN/NaN') {
                return null;
            }
            const [day, month, year] = dateString.split('/');
            return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        }
        function dateToString(dateString) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${day}/${month}/${year}`;
        }
        function findFieldValue(fieldName) {
            for (const section of sections.value) {
                for (const field of section.fields) {
                    if (field.label === fieldName && field.value != null) {
                        return field.value;
                    }
                }
            }
            return null;
        }
        function findFieldValueById(fieldId) {
            for (const section of sections.value) {
                for (const field of section.fields) {
                    if (field.id === fieldId && field.value != null) {
                        return field.value;
                    }
                }
            }
            return null;
        }
        function findFieldById(fieldId) {
            for (const section of sections.value) {
                for (const field of section.fields) {
                    if (field.id === fieldId) {
                        return field;
                    }
                }
            }
            return null;
        }
        function loadFieldsFromObject(fieldMappings) {
            Object.keys(fieldMappings).forEach(fieldName => {
                sections.value.forEach(section => {
                    section.fields.forEach((field) => {
                        if (field.label === fieldName) {
                            field.value = fieldMappings[fieldName];
                        }
                    });
                });
            });
        }
        function sectionAllowed(section) {
            if (!section.rule) {
                return true;
            }
            const [ruleKey, ruleValue] = section.rule.split(':').map((s) => s.trim());
            const ruleValues = ruleValue.split(',').map((s) => s.trim());
            for (let i = 0; i < sectionNo.value; i++) {
                const sec = sections.value[i];
                for (const field of sec.fields) {
                    if (field.id === ruleKey && ruleValues.includes(field.value)) {
                        return true;
                    }
                }
            }
            return false;
        }
        function inputControlGoNext(onFinished = null, before = null) {
            validationText.value = '';
            let allOK = true;
            if (before) {
                if (!before()) {
                    return;
                }
            }
            for (const field of sections.value[sectionNo.value].fields) {
                if (field.required && (!field.value || field.value === "")) {
                    validationText.value = field.validationText;
                    allOK = false;
                    break;
                }
                if (field.type === 'datetext' && field.value.length < 10) {
                    validationText.value = "Please enter date in the format dd/mm/yyyy";
                    allOK = false;
                    break;
                }
                if (field.strongPass != undefined && field.strongPass == false) {
                    validationText.value = "Your password is not strong enough";
                    allOK = false;
                    break;
                }
            }
            if (allOK) {
                let allowed = false;
                breadCrumb.value.push({ sectionNo: sectionNo.value });
                while (!allowed) {
                    validationText.value = null;
                    sectionNo.value++;
                    if (!sections.value[sectionNo.value]) {
                        if (onFinished) {
                            onFinished();
                            return;
                        }
                    }
                    else {
                        allowed = sectionAllowed(sections.value[sectionNo.value]);
                    }
                }
                currentPageNumber.value++;
                inputSections.value.next(sectionNo.value);
            }
            setTimeout(() => { validationText.value = null; }, 4000);
        }
        function inputControlGoBack() {
            const crumb = breadCrumb.value.pop();
            sectionNo.value = crumb.sectionNo;
            validationText.value = null;
            currentPageNumber.value--;
            inputSections.value.back(sectionNo.value);
        }
        function preValidate() {
            validationText.value = null;
            const now = new Date();
            sections.value[sectionNo.value].fields.forEach((field) => {
                if (field.type === 'datetext' && field.value) {
                    const [day, month, year] = field.value.split('/');
                    const date = new Date(year, month - 1, day);
                    if (field.future && date < now) {
                        validationText.value = `${field.label} must be in the future`;
                        return false;
                    }
                    if (field.past && date > now) {
                        validationText.value = `${field.label} must be in the past`;
                        return false;
                    }
                }
            });
            return !validationText.value;
        }
        // --- Page methods ---
        function onLoad() {
            getAiopSection('InsuranceMainSections.json', () => {
                sections.value = state.sectionJson;
                if (route.params.id) {
                    getPolicy(route.params.id, (p) => {
                        policy.value = p;
                        populateFields();
                    });
                }
                getCustomer();
                getInsuranceProviders((res) => {
                    res = res.filter((item) => item.buildings === true || item.contents === true || item.gadget === true
                        || item.car === true || item.motorbike === true || item.pet === true
                        || item.life === true || item.other === true)
                        .filter((item, index, self) => index === self.findIndex((t) => t.name === item.name));
                    const providerField = findFieldById('provider');
                    if (providerField) {
                        providerField.showAvatars = true;
                        providerField.items = res.map((provider) => ({
                            name: provider.name.replace(/\w\S*/g, (txt) => {
                                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                            }),
                            logoUri: provider.logoUri
                        }));
                    }
                });
                getPolicyTypes((res) => {
                    const policyTypeField = findFieldById('policyType');
                    if (policyTypeField) {
                        policyTypeField.items = res.map((policyType) => {
                            return policyType.name.replace(/\w\S*/g, (txt) => {
                                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                            });
                        });
                    }
                });
            });
        }
        function populateFields() {
            const fieldMappings = {
                'Policy type': policy.value.policyType.name,
                'Provider': policy.value.provider.name,
                'Policy number': policy.value.policyNumber,
                'Start date': dateToString(policy.value.startDate),
                'Renewal date': dateToString(policy.value.endDate),
                'Premium': policy.value.annualPremium || policy.value.monthlyPremium,
                'Excess': policy.value.excess,
                'No claims (years)': policy.value.noClaimsYears,
                'Sole or joint': policy.value.soleOrJoint,
                'Sum assured': policy.value.sumAssured,
                'Cover type': policy.value.coverType,
                'Type': policy.value.travelCoverType,
                'Coverage': policy.value.travelCoverage,
                'How do you pay': policy.value.annualPremium ? 'Annually' : 'Monthly',
                'Address': policy.value.insuredItems[0]?.addressInsured,
                'Make': policy.value.insuredItems[0]?.vehicleMake,
                'Model': policy.value.insuredItems[0]?.vehicleModel,
                'Registration': policy.value.insuredItems[0]?.vehicleRegistration,
                'Name': policy.value.insuredItems[0]?.name,
                'Value insured': policy.value.insuredItems[0]?.valueInsured,
                'Breed': policy.value.insuredItems[0]?.petBreed,
                'Date of birth': dateToString(policy.value.insuredItems[0]?.petBirthdate),
                'Device Type': policy.value.insuredItems[0]?.itemType
            };
            loadFieldsFromObject(fieldMappings);
        }
        function addPolicy() {
            const policyType = {
                name: findFieldValueById('policyType') || null,
            };
            const provider = {
                name: findFieldValueById('provider') || null,
            };
            const addressObject = findFieldValue('Address') || null;
            const addressInsured = {
                line1: addressObject?.line1 || null,
                line2: addressObject?.line2 || null,
                line3: addressObject?.line3 || null,
                town: addressObject?.town || null,
                postCode: addressObject?.postCode || null,
            };
            const insuredItems = [];
            const insuredItem = ({
                itemType: findFieldValueById('policyType') || null,
                addressInsured: addressInsured || null,
                name: findFieldValueById('name') || null,
                petBreed: findFieldValueById('breed') || null,
                petBirthDate: stringToDate(findFieldValueById('dateOfBirth')) || new Date('1900-01-01'),
                vehicleMake: findFieldValueById('make') || null,
                vehicleModel: findFieldValueById('model') || null,
                vehicleRegistration: findFieldValueById('registration') || null,
                valueInsured: findFieldValueById('valueInsured') || 0,
            });
            insuredItems.push(insuredItem);
            const policyData = ({
                policyType: policyType,
                policyNumber: findFieldValueById('policyNumber') || null,
                provider: provider,
                insuredItems: insuredItems,
                payFrequency: findFieldValueById('payFrequency') || null,
                startDate: stringToDate(findFieldValueById('startDate')) || null,
                endDate: stringToDate(findFieldValueById('renewalDate')) || null,
                annualPremium: findFieldValueById('payFrequency') === 'Annually' ? findFieldValueById('premium') : null,
                monthlyPremium: findFieldValueById('payFrequency') === 'Monthly' ? findFieldValueById('premium') : null,
                excess: findFieldValueById('excess') || null,
                noClaimsYears: findFieldValueById('noClaimsYears') || null,
                soleOrJoint: findFieldValueById('soleOrJoint') || null,
                sumAssured: findFieldValueById('sumAssured') || null,
                coverType: findFieldValueById('coverType') || null,
                travelCoverType: findFieldValueById('type') || null,
                travelCoverage: findFieldValueById('coverage') || null,
            });
            if (route.params.id) {
                policyData.id = route.params.id;
            }
            const handleResponse = (res) => {
                if (res) {
                    if (route.params.id) {
                        getPolicy(route.params.id, null, true);
                    }
                    getInsuranceInfo(null, true);
                    router.push({ path: '/insurancesuccess', query: { policyId: res.id } });
                }
            };
            if (!route.params.id) {
                apiAddPolicy(policyData, handleResponse);
            }
            else {
                updatePolicy(policyData, handleResponse);
            }
        }
        function sectionsAvailableCount(insuranceType) {
            const sectionsNoRule = sections.value.filter(section => !section.rule);
            const sectionsMatchingRule = sections.value.filter(section => section.rule && section.rule.includes(insuranceType));
            return sectionsNoRule.length + sectionsMatchingRule.length;
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_progress_linear = _resolveComponent("v-progress-linear");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: insuranceHeader.value,
                    bgcolor: "white",
                    border: "0"
                }, null, 8, ["title"]),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).customer && _unref(state).policyTypes
                }, null, 8, ["customer"]),
                (totalPages.value > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_v_progress_linear, {
                            "model-value": progressValue.value,
                            rounded: ""
                        }, null, 8, ["model-value"])
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).customer && _unref(state).policyTypes && (policy.value || !_unref(route).params.id))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createVNode(InputSections, {
                                        ref_key: "inputSections",
                                        ref: inputSections,
                                        sections: sections.value,
                                        theme: "light"
                                    }, null, 8, ["sections"]),
                                    (validationText.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                            _createElementVNode("p", null, _toDisplayString(validationText.value), 1)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_5, [
                                        _createVNode(MGButton, {
                                            alt: false,
                                            text: "Next",
                                            arrow: true,
                                            fullWidth: true,
                                            disabled: !isCurrentSectionValid.value,
                                            onClick: _cache[0] || (_cache[0] = ($event) => (inputControlGoNext(addPolicy, preValidate)))
                                        }, null, 8, ["disabled"]),
                                        (currentPageNumber.value > 0)
                                            ? (_openBlock(), _createBlock(MGButton, {
                                                key: 0,
                                                stacked: true,
                                                outline: true,
                                                fullWidth: true,
                                                text: "Back",
                                                onClick: _cache[1] || (_cache[1] = ($event) => (inputControlGoBack()))
                                            }))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
